import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Select from './reactSelect/select.component';
import { periodsSelector, periodOrCurrentSelector } from './store/selectors';
import { selectPeriod } from './store/actions';
import { PeriodPropTypes, PeriodsPropTypes } from './propTypes/period';

class PeriodDropdown extends PureComponent {
  static propTypes = {
    periods: PropTypes.arrayOf(PeriodsPropTypes).isRequired,
    period: PeriodPropTypes.isRequired,
    selectPeriod: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    disabled: false,
  };

  onPeriodChange = selectedPeriod => {
    const { periods, selectPeriod, onChange } = this.props;
    const value = selectedPeriod ? selectedPeriod.value : null;
    const periodToSelect = periods.find(period => period.name === value);

    if (periodToSelect) {
      selectPeriod(periodToSelect);
      if (onChange) {
        onChange(periodToSelect);
      }
    }
  };

  render() {
    const { period, periods, disabled } = this.props;

    return (
      <Select
        className="select-period"
        clearable={false}
        name="period"
        options={periods}
        labelKey="name"
        onChange={this.onPeriodChange}
        disabled={disabled}
        scrollMenuIntoView={false}
        value={period}
        virtualized
      />
    );
  }
}

export default connect(
  function mapStateToProps(state) {
    return {
      period: periodOrCurrentSelector(state),
      periods: periodsSelector(state),
    };
  },
  {
    selectPeriod,
  }
)(PeriodDropdown);
